import MixinScroll from '../mixin-scroll'
import MixinResize from '../mixin-resize'
import { getPosition } from '../utils/position'

export default
{
    mixins: [
        MixinScroll,
        MixinResize
    ],

    props:
    {
        transform: { type: String, default: 'translateZ(0)' },
        power: { type: Number, default: -0.25 }
    },

    data()
    {
        return { }
    },
    
    mounted()
    {
        this.lastTransform = this.transform
        
        this.$nextTick(this.setData)
        this._raf = requestAnimationFrame(this.onEnterFrame)
    },

    destroyed()
    {
        cancelAnimationFrame(this._raf)
    },

    methods:
    {
        onEnterFrame()
        {
            this._raf = requestAnimationFrame(this.onEnterFrame)
            this.setTransform()
        },

        onScroll()
        {
            // Hide warning
        },
        
        onResized()
        {
            this.setData()
        },

        setTransform()
        {
            const scrollMiddle = this.scroll.smoothY + this.resize.height / 2
            const objectMiddle = this.top + this.height / 2

            const gap = scrollMiddle - objectMiddle
            const y = gap * this.power
            const transform = 'translateY(' + y.toFixed(1) + 'px)'

            const newTransform = this.transform + ' ' + transform
            if (newTransform !== this.lastTransform)
            {
                this.$el.style.transform = newTransform
                this.lastTransform = newTransform
            }
        },

        setData()
        {
            this.$el.style.transform = this.transform
            this.top = getPosition(this.$el)[1]
            this.height = this.$el.offsetHeight
            this.$el.style.transform = this.lastTransform
        }
    }
}